// extracted by mini-css-extract-plugin
module.exports = {"filterWrapper":"styles_filterWrapper__zTCKb","priceMenu":"styles_priceMenu__1A2Aw","chip":"styles_chip__faXGR","chipSelected":"styles_chipSelected__6iAnd"};